export const JOBS_INPUT = 'JOBS_INPUT' as const;
export const JOBS_OUTPUT = 'JOBS_OUTPUT' as const;
